import React, { lazy, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Context from './context';
import Loading from './components/Loading';
import {
  getFlatMenuItems,
  isMenuItemVisibleForUser,
} from './constants/menus';

const ApiDocs = lazy(() => import('./containers/ApiDocs'));
const NotFound = lazy(() => import('./containers/NotFound'));
const UserSettings = lazy(() => import('./containers/Settings'));

const renderRoutes = () => (
  <Context.Consumer>
    {(context) => (
      <Routes>
        <Route path="/apidocs" element={<ApiDocs />} />
        <Route
          path="/sysops-apidocs"
          element={<ApiDocs swaggerUrl="/admin/systemoperator/swagger" />}
        />
        {/* TODO: implement a MFA option
        <Route path="/mfa" element={<SelectMFA />} /> */}
        <Route path="/settings" Component={UserSettings} />
        {getFlatMenuItems()
          // Sort items with component to the top of the list -> react-router issue!
          .sort((item) => (item.component === undefined ? 1 : -1))
          .map((item) => {
            if (isMenuItemVisibleForUser(item, context)) {
              const Component = item.component || NotFound;
              return (
                <Route
                  key={item.name}
                  path={`${item.url}/*`}
                  element={<Component />}
                />
              );
            }
            return null;
          })}
        <Route path="/" element={<Navigate to="/frontpage" replace />} />
        <Route
          path="/shippers"
          element={<Navigate to="/relationships-created" replace />}
        />
        <Route
          path="/retailers"
          element={<Navigate to="/relationships-received" replace />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    )}
  </Context.Consumer>
);

const AppRoutes = () => (
  <Suspense fallback={<Loading />}>
    {
      renderRoutes()
    }
  </Suspense>
);

export default AppRoutes;
